import {useState, useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'
import {http} from '../../../shared/http'
import {isLoggedIn} from '../../../shared/session'
import {isAppRoute} from '../../../shared/app-routes'
import {useSharedStore} from '../../../state/shared-store-context'

const ANIM_MS = 270

export const useNotificationSummary = () => {
    const {sharedState} = useSharedStore()
    const [displayState, setDisplayState] = useState({summary: null, fadingOut: false})
    const displayStateRef = useRef(displayState)
    const fadeTimerRef = useRef(null)

    const updateDisplayState = (state) => {
        displayStateRef.current = state
        setDisplayState(state)
    }

    useEffect(() => {
        const summary = sharedState.notifBadgeSummary
        if (!summary) return
        const hasContent = summary.total > 0
        if (hasContent) {
            if (fadeTimerRef.current) {
                clearTimeout(fadeTimerRef.current)
                fadeTimerRef.current = null
            }
            updateDisplayState({summary, fadingOut: false})
        } else if (displayStateRef.current.summary?.total > 0) {
            updateDisplayState({...displayStateRef.current, fadingOut: true})
            fadeTimerRef.current = setTimeout(() => {
                updateDisplayState({summary, fadingOut: false})
                fadeTimerRef.current = null
            }, ANIM_MS)
        } else {
            updateDisplayState({summary, fadingOut: false})
        }
        return () => { if (fadeTimerRef.current) clearTimeout(fadeTimerRef.current) }
    }, [sharedState.notifBadgeSummary])

    return {notifSummary: displayState.summary, fadingOut: displayState.fadingOut}
}

export const useNotificationSummaryRefresh = () => {
    const location = useLocation()
    const {sharedState, actions} = useSharedStore()
    const loggedIn = isLoggedIn()

    useEffect(() => {
        if (!loggedIn || !isAppRoute(location.pathname)) return
        let active = true
        http.get('/api/v1/notifications/summary').then(r => {
            if (active) actions.setNotifBadgeSummary(r.data.summary || {})
        }).catch(() => {})
        return () => { active = false }
    }, [loggedIn, location.pathname, sharedState.notificationsCheckedAt, sharedState.followersSeenAt,
        sharedState.messagesSeenAt, sharedState.notificationSummaryRefreshAt, actions])
}
